import(/* webpackMode: "eager" */ "/vercel/path0/app/projects/GestorEscolar/page.tsx");
